import React from 'react';
import { Link } from 'react-router-dom';
import Icons from '../icons';
import './Nav.css';

const Nav = () => {
  return (
    <div>
      <nav id='menu'>
        <ul>
          <li>
          <img src={Icons.logo} className="hd-img" alt="logo" />
          </li>
         

        </ul>
      </nav>
      <div className="nav-div-h">
      </div>
    </div>
  );
};

export default Nav;
